import { IItem } from '../../../../../../../shared/analytics/e-commerce/models/IItem';
import { flatten } from '../../../../../../../shared/utils/flatten';
import { IAncillary } from '../../../../../../domain/ancillary/domain/models/IAncillary';
import { IExtra } from '../../../../../../domain/ancillary/domain/models/IExtra';

export function adaptAncillaryToItems(ancillary: IAncillary): IItem[] {
	if (ancillary.extras && ancillary.extras.length) {
		return adaptExtrasToItems(ancillary.extras);
	}

	if (!ancillary.price) {
		return [];
	}

	return [
		{
			id: ancillary.id.toString(),
			name: ancillary.name,
			category: 'Ancillaries',
			price: ancillary.price,
		},
	];
}

export function adaptExtrasToItems(extras: IExtra[]): IItem[] {
	const nestedItems = extras.map(adaptExtraToItems);

	return flatten(nestedItems);
}

export function adaptExtraToItems(extra: IExtra): IItem[] {
	return extra.variants.map((variant) => ({
		id: variant.id.toString(),
		name: variant.name,
		category: 'Extra',
		price: variant.price,
	}));
}
